export default __webpack_public_path__ + "static/media/solution-certificate.85abdcfc.png";